
import { Vue, Component } from "vue-property-decorator";
import { UFliterals } from "@/utils/literals";
import DemoRoom from "@/components/task/assignment/components/DemoRoom.vue";
import DemoStudent from "@/components/task/assignment/components/DemoStudent.vue";

@Component({
  components: { DemoStudent, DemoRoom },
})
export default class ScoreDetailPage extends Vue {
  subjects = ["A", "B", "C", "D"];
  rooms = ["001", "002"];
  assignment = {
    "001": ["C", "D"],
    "002": ["A", "B"],
  };
  payoff = {
    A: {
      "001": 24,
      "002": 78,
    },
    B: {
      "001": 51,
      "002": 54,
    },
    C: {
      "001": 94,
      "002": 47,
    },
    D: {
      "001": 60,
      "002": 56,
    },
  };
  score = 286;

  getUF(key: string): string {
    return UFliterals[key] || "";
  }
}
